import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { faArrowRightFromBracket } from '@fortawesome/free-solid-svg-icons'

import {
  $DCprimaryColor,
  DcButton,
  DcDiv,
  DcFlexBox,
  DcIcon,
  DcInput,
  DcText,
  PixelFactoryContext,
} from 'pixel-base'
import ClickOutside from 'rechat-react-click-outside'
import { getUser, changePasswordAPI } from 'utils/api-routes.util'
import ArrowLeftIcon from 'utils/icons/arrow-left-icon'
import EmailAtIcon from 'utils/icons/email-at-icon'
import { SettingsIcon } from 'utils/icons/icon'
import PasswordIcon from 'utils/icons/password-icon'

const ProfileSection = () => {
  const { showPageLoader, hidePageLoader, showSuccess, showFailure } =
    React.useContext(PixelFactoryContext) as any
  const [showChangePasswordModal, setShowChangePasswordModal] =
    React.useState(false)
  const [accountPopup, setAccountPopup] = React.useState(false)
  const navigate = useNavigate()

  const { user } = getUser()

  const handleCustomActionClick = (action) => {
    if (action === 'logout') {
      try {
        // Clear all local storage
        localStorage.clear()
        sessionStorage.clear()

        // Clear any pending requests or subscriptions
        window.dispatchEvent(new Event('auth-change'))

        // Close any open modals
        setAccountPopup(false)
        setShowChangePasswordModal(false)

        // Navigate to login
        navigate('/auth/login', { replace: true })

        // Force a page reload to clear any remaining state
        window.location.reload()
      } catch (error) {
        console.error('Error during logout:', error)
        // If navigation fails, force reload to login page
        window.location.href = '/auth/login'
      }
    }
  }
  // ------------password section------------------------

  const [data, setData] = React.useState({
    new_password: '',
    confirm_password: '',
  })

  const handleSubmit = (e) => {
    e.preventDefault()
    if (data.new_password !== data.confirm_password) {
      showFailure('Passwords do not match')
      return
    }

    showPageLoader()
    changePasswordAPI(
      {
        password: data.new_password,
        confirm_password: data.confirm_password,
      },
      user.id,
    ).subscribe({
      next: (res: any) => {
        hidePageLoader()
        if (res.response?.data || res.response?.message) {
          showSuccess(res.response.message || 'Password changed successfully')
          setShowChangePasswordModal(false)
          setAccountPopup(false)
          setData({ new_password: '', confirm_password: '' })
        } else if (res.response?.error) {
          showFailure(res.response.error)
        }
      },
      error: (err: any) => {
        hidePageLoader()
        showFailure(err?.response?.error || 'Failed to change password')
      },
    })
  }

  // Safely get user data with fallbacks
  const userName = user?.name || ''
  const firstLetter = userName?.[0] || ''
  const userEmail = user?.user_email || ''
  const userType = user?.user_type?.description || 'User'

  return (
    <DcDiv>
      <DcDiv
        display="flex"
        height="44px"
        width="44px"
        border="1px solid #d2d4e4"
        style={{
          justifyContent: 'center',
          alignItems: 'center',
          borderRadius: '50%',
          cursor: 'pointer',
        }}
        onClick={() => {
          setAccountPopup(true)
        }}
      >
        <DcFlexBox justifyContent="center" alignItems="center">
          <DcDiv
            textSize="16px"
            textTransform="uppercase"
            style={{ fontWeight: '500', margin: '0', color: $DCprimaryColor }}
          >
            {firstLetter}
          </DcDiv>
        </DcFlexBox>
      </DcDiv>
      <ClickOutside onClickOutside={() => setAccountPopup(false)}>
        <DcFlexBox
          flexDirection="column"
          height="auto"
          width="280px"
          position="absolute"
          borderRadius="0.375rem"
          boxShadow="0px 0px 5px #ccc"
          top="60px"
          right="35px"
          zIndex="1111111111111"
          backgroundColor="#fff"
          transition="0.3s all"
          box-shadow="0 2px 12px -1px rgba(67,71,107,.2)"
          display={accountPopup ? 'flex' : 'none'}
          className={accountPopup && 'ActivePopup'}
        >
          <DcFlexBox
            padding="16px 24px"
            style={{ borderBottom: '1px solid #d2d4e4' }}
          >
            <DcFlexBox gap="10px">
              <DcFlexBox
                height="43px"
                width="52px !important"
                style={{ borderRadius: '50%', width: '52px !important' }}
                border="1px solid #d2d4e4"
                justifyContent="center"
                alignItems="center"
                gap="10px"
              >
                <DcText
                  margin="0"
                  style={{
                    margin: '0',
                    display: 'inline-flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '35px',
                    height: '35px',
                    borderRadius: '50%',
                    fontWeight: '500',
                    border: '1px solid #d2d4e4',
                    color: $DCprimaryColor,
                    verticalAlign: 'middle',
                  }}
                  textTransform="uppercase"
                  textAlign="center"
                >
                  {firstLetter}
                </DcText>
              </DcFlexBox>
              <DcFlexBox flexDirection="column">
                <DcText
                  style={{ fontWeight: '500', color: '#2e314a' }}
                  lineHeight="1.5rem"
                  textSize=".813rem"
                >
                  {userName}
                </DcText>
                <DcText
                  style={{ color: '#787c9e' }}
                  textSize=".75rem"
                  lineheight="1.5"
                >
                  {userType}
                </DcText>
              </DcFlexBox>
            </DcFlexBox>
            <DcFlexBox width="auto">
              {showChangePasswordModal && (
                <ArrowLeftIcon
                  onClick={() => {
                    setShowChangePasswordModal(false)
                  }}
                  size={20}
                />
              )}
            </DcFlexBox>
          </DcFlexBox>
          {showChangePasswordModal ? (
            <>
              <form onSubmit={handleSubmit}>
                <DcFlexBox
                  flexDirection="column"
                  padding=" 1.5rem 1rem"
                  gap="10px"
                >
                  <DcInput
                    required
                    type={'password'}
                    name={'password'}
                    placeholder={'Enter your new password'}
                    value={data.new_password}
                    onChange={(e) =>
                      setData({ ...data, new_password: e.target.value })
                    }
                  />

                  <DcInput
                    required
                    type={'password'}
                    name={'cpassword'}
                    placeholder={'Confirm your new password'}
                    value={data.confirm_password}
                    onChange={(e) =>
                      setData({ ...data, confirm_password: e.target.value })
                    }
                  />
                </DcFlexBox>

                <DcFlexBox
                  justifyContent="flex-end"
                  padding=" 0 1rem 1rem 1rem"
                  flexEnd
                >
                  <DcButton size="sm" variant="primary" type="submit">
                    Save
                  </DcButton>
                </DcFlexBox>
              </form>
            </>
          ) : (
            <DcFlexBox flexDirection="column">
              <DcFlexBox padding="1rem 1.5rem" flexDirection="column">
                <DcDiv
                  hoverStyle={{
                    color: $DCprimaryColor,
                    curser: 'pointer',
                  }}
                  padding="12px 0"
                  cursor="pointer"
                  display="flex"
                  style={{
                    flexDirection: 'row',
                    alignItems: 'center',
                    gap: '10px',
                  }}
                >
                  <DcDiv style={{ color: 'inherit' }} width="24px">
                    <EmailAtIcon />
                  </DcDiv>
                  <DcText
                    copyToClipboard={true}
                    charLimit={18}
                    tooltipPlacement="top"
                    copyTooltipPlacement="top"
                    textSize="13.8px"
                  >
                    {userEmail}
                  </DcText>
                </DcDiv>
                <DcDiv
                  hoverStyle={{
                    color: $DCprimaryColor,
                    curser: 'pointer',
                  }}
                  cursor="pointer"
                  padding="12px 0"
                  display="flex"
                  style={{
                    flexDirection: 'row',
                    alignItems: 'center',
                    gap: '10px',
                  }}
                >
                  <Link
                    style={{
                      display: 'flex',
                      gap: '10px',
                      color: 'inherit',
                      textDecoration: 'none',
                    }}
                    to="/admin"
                  >
                    <DcDiv width="24px">
                      <SettingsIcon color="inherit" fontSize="20px" />
                    </DcDiv>
                    <DcText textSize="13.8px">Settings</DcText>
                  </Link>
                </DcDiv>
                <DcDiv
                  hoverStyle={{
                    color: $DCprimaryColor,
                    curser: 'pointer',
                  }}
                  padding="12px 0"
                  cursor="pointer"
                  display="flex"
                  style={{
                    flexDirection: 'row',
                    alignItems: 'center',
                    gap: '10px',
                  }}
                  onClick={() => {
                    setShowChangePasswordModal(true)
                  }}
                >
                  <DcDiv width="24px">
                    <PasswordIcon size={20} />
                  </DcDiv>
                  <DcText textSize="13.8px">Change Password</DcText>
                </DcDiv>
              </DcFlexBox>
              <DcDiv
                onClick={() => handleCustomActionClick('logout')}
                hoverStyle={{
                  color: $DCprimaryColor,
                  curser: 'pointer',
                }}
                cursor="pointer"
                color="#43476b"
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'flex-start',
                  justifyContent: 'flex-start',
                  borderTop: '1px solid #d2d4e4',
                  gap: ' 10px',
                  width: '100%',
                  padding: '28px 24px',
                }}
              >
                <DcDiv width="20px">
                  <DcIcon
                    color={'inherit'}
                    curser="pointer"
                    fontSize="20px"
                    icon={faArrowRightFromBracket}
                  />
                </DcDiv>
                <DcText
                  textSize=".813rem"
                  width="20px"
                  verticalAlign="middle"
                  style={{ color: 'inherit', curser: 'pointer' }}
                >
                  Sign out
                </DcText>
              </DcDiv>
            </DcFlexBox>
          )}
        </DcFlexBox>
      </ClickOutside>
    </DcDiv>
  )
}

export default ProfileSection
